// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".head-bar_Xj7Nd{background-color:#4a5b8b!important}@media only screen and (min-width:600px){.variableGutter_38XVF{padding-left:var(--width-navigation-desctop)}}@media only screen and (min-width:1240px){.variableGutter_38XVF{padding-left:var(--width-navigation-infinity)}}.content_2SuXm{padding-bottom:var(--gutter-container-bottom);min-width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"head-bar": "head-bar_Xj7Nd",
	"variableGutter": "variableGutter_38XVF",
	"content": "content_2SuXm"
};
module.exports = ___CSS_LOADER_EXPORT___;
